import React from 'react';
import styled from 'styled-components';
import ContactDiv from './ContactDiv';
import LegalDiv from './LegalDiv';

const Footer = () => {
  return (
    <FooterElement>
      <Contact />
      <Legal />
    </FooterElement>
  );
};

const FooterElement = styled.footer`
  grid-area: footer;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.KBBeige};
  padding-bottom: 35px;
  margin-top: auto;
  min-height: 230px;
  z-index: ${({ theme }) => theme.layers.footer};

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    flex-direction: row-reverse;
    padding-left: 15px;
    padding-right: 15px;
    min-height: 150px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    padding-left: 100px;
    padding-right: 100px;
  }
`;

const Contact = styled(ContactDiv)`
  margin: -10px auto 35px auto;
  width: 280px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    margin: -10px 0 0 auto;
    padding-bottom: 10px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    width: 400px;
  }
`;

const Legal = styled(LegalDiv)`
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    text-align: left;
    margin-top: 25px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    margin-top: 40px;
  }
`;

export default Footer;
